import React, { useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import { FaCheckCircle, FaTimesCircle, FaPhoneAlt, FaShoppingBag, FaShoppingCart, FaTrash } from "react-icons/fa";
export default function OrderStatus() {
    const orderNo = localStorage.getItem("orderNo");
    const isSuccess = !!orderNo;
    return (
        <div>
            <Header />
            <div className="order-status-wrapper">
                <div className="order-status-card">
                    <div>
                        {isSuccess ? (
                            <FaCheckCircle className="status-icon success" size={90} />
                        ) : (
                            <FaTimesCircle className="status-icon failed" size={90} />)}
                    </div>
                    <h2 className={`order-status-title ${isSuccess ? "success" : "failed"}`}>
                        {isSuccess
                            ? "🎉 Yay! Your Order is Confirmed!"
                            : "😔 Oops! Payment Unsuccessful"}
                    </h2>
                    <p className="order-status-message">
                        {isSuccess ? (
                            <>
                                Thank you for choosing
                                <strong> Senthan Amuthan Kids Wear ⭐</strong>
                                <br />
                                Your payment was successful, and your order
                                will be shipped soon with love and care.
                            </>
                        ) : (
                            <>
                                No worries — please try again to complete your
                                purchase.
                                <br />
                                Your selected items are still waiting for you 🛍️
                            </>
                        )}
                    </p>
                    {isSuccess && (
                        <div className="order-id-box">
                            <div className="order-id-label">
                                Order ID
                            </div>
                            <div className="order-id">
                                SA{orderNo}
                            </div>
                        </div>
                    )}
                    <div className="support-box">
                        <p>
                            <strong>
                                Need help? Our customer care team is here for you.
                            </strong>
                        </p>
                        <p>
                            Please reach out within 2 hours of placing your order.
                        </p>
                        <a href="tel:9360990836" className="support-phone-btn"><FaPhoneAlt />9360990836</a>
                    </div>
                    <Link to="/" className="continue-shopping-btn">
                        <FaShoppingBag />Continue Shopping
                    </Link>
                </div>
            </div>
            <Footer />
        </div>
    );
}